import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: false,
  refetchToggle: false,
};

export const examSidebarSlice = createSlice({
  name: "examSidebar",
  initialState,
  reducers: {
    swap_settings_question: (state, action) => {
      state.value = action.payload;
    },
    toggle_refetch: (state) => {
      state.refetchToggle = !state.refetchToggle;
    },
  },
});

export const { swap_settings_question, toggle_refetch } = examSidebarSlice.actions;

export default examSidebarSlice.reducer;
